import Panel from './Panel';

export { PanelOpenWidth, PanelOpenDurationMs } from './Panel';
export default Panel;
